export interface PageSEOEntry {
  title: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogImage: string;
  noindex: boolean;
}

const BASE_URL = 'https://portal.yodlee.com';
const OG_IMAGE = `${BASE_URL}/landing_page.svg`;

export const DEFAULT_SEO: PageSEOEntry = {
  title: 'Yodlee ID Portal - Manage Your Connected Financial Accounts',
  description:
    'Yodlee ID Portal lets you securely view and manage all your linked financial accounts in one place. Sign up or sign in to take control of your financial data.',
  ogTitle: 'Yodlee ID Portal - Manage Your Connected Financial Accounts',
  ogDescription: 'Securely view and manage all your linked financial accounts with Yodlee ID Portal.',
  ogUrl: `${BASE_URL}/`,
  ogImage: OG_IMAGE,
  noindex: false,
};

export const SEO_CONFIG: Record<string, PageSEOEntry> = {
  '/': DEFAULT_SEO,
  '/auth/login': {
    title: 'Sign In - Yodlee ID Portal',
    description:
      'Sign in to Yodlee ID Portal to view and manage your connected financial accounts and institutions.',
    ogTitle: 'Sign In - Yodlee ID Portal',
    ogDescription: 'Sign in to manage your connected financial accounts.',
    ogUrl: `${BASE_URL}/auth/login`,
    ogImage: OG_IMAGE,
    noindex: false,
  },
  '/auth/signup': {
    title: 'Sign Up - Yodlee ID Portal',
    description:
      'Create your free Yodlee ID Portal account to manage connections between your financial institutions and the apps you trust.',
    ogTitle: 'Sign Up - Yodlee ID Portal',
    ogDescription: 'Create your free Yodlee ID Portal account.',
    ogUrl: `${BASE_URL}/auth/signup`,
    ogImage: OG_IMAGE,
    noindex: false,
  },
  '/auth/verify': {
    title: 'Verify Your Identity - Yodlee ID Portal',
    description: 'Enter your verification code to complete your Yodlee ID Portal sign-up.',
    ogTitle: 'Verify Your Identity - Yodlee ID Portal',
    ogDescription: 'Complete your Yodlee ID Portal verification.',
    ogUrl: `${BASE_URL}/auth/verify`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
  '/auth/create-profile': {
    title: 'Create Your Profile - Yodlee ID Portal',
    description: 'Set up your Yodlee ID Portal profile to get started managing your financial connections.',
    ogTitle: 'Create Your Profile - Yodlee ID Portal',
    ogDescription: 'Set up your Yodlee ID profile.',
    ogUrl: `${BASE_URL}/auth/create-profile`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
  '/auth/reset-password': {
    title: 'Reset Password - Yodlee ID Portal',
    description: 'Reset your Yodlee ID Portal password to regain access to your account.',
    ogTitle: 'Reset Password - Yodlee ID Portal',
    ogDescription: 'Reset your Yodlee ID Portal password.',
    ogUrl: `${BASE_URL}/auth/reset-password`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
  '/dashboard': {
    title: 'Dashboard - Yodlee ID Portal',
    description:
      'View and manage all your connected financial institutions and accounts on the Yodlee ID Portal dashboard.',
    ogTitle: 'Dashboard - Yodlee ID Portal',
    ogDescription: 'Your Yodlee ID Portal dashboard.',
    ogUrl: `${BASE_URL}/dashboard`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
  '/settings': {
    title: 'Settings - Yodlee ID Portal',
    description:
      'Manage your Yodlee ID Portal account settings, security, and preferences.',
    ogTitle: 'Settings - Yodlee ID Portal',
    ogDescription: 'Manage your account settings.',
    ogUrl: `${BASE_URL}/settings`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
  '/support': {
    title: 'Support - Yodlee ID Portal',
    description:
      'Get help with your Yodlee ID Portal account, connections, and financial data management.',
    ogTitle: 'Support - Yodlee ID Portal',
    ogDescription: 'Get help with your Yodlee ID Portal account.',
    ogUrl: `${BASE_URL}/support`,
    ogImage: OG_IMAGE,
    noindex: true,
  },
};
